<template>
  <el-input placeholder="请输入搜索关键字" v-model="value" clearable @clear="search()">
    <template slot="append">
      <el-button type="primary" class="search" @click="search()">{{ textButton }}</el-button>
    </template>
  </el-input>
</template>

<script>
export default {
  name: "InputWithButton",
  props: {
    textButton: {
      type: String,
      required: false,
      default: '搜索'
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    search() {
      this.$emit('search', this.value);
    }
  }
}
</script>

<style scoped lang="scss">
$colorMain: #28cccb;

button.search {
  background-color: $colorMain;
  color: #FFFFFF;
  border: 1px solid $colorMain;
  border-bottom-left-radius: unset;
  border-top-left-radius: unset;
}
</style>
